// The verify read's response. Every figure here was recorded when the
// document was issued; none is recomputed, so what the page shows always
// matches the paper the reader is holding.

export type VerificationStatus = "AVAILABLE" | "EXPIRED";

export interface AttestedDocument {
  reference: string;
  status: VerificationStatus;
  content_hash: string;
  kind: string;
  locale: string;
  template_version: string;
  // "Issued to" is read as issued FOR: the tenant the document is about.
  issued_to_type: string;
  issued_to: string;
  // The KIND of actor that produced it. The generating user's name is never
  // published, so there is no field here to hold one.
  generated_by_type?: string;
  period_start: string;
  period_end: string;
  row_count: number;
  transaction_count: number;
  total_volume: string;
  currency: string;
  generated_at: string;
  expires_at: string;
  retention_days: number;
  // Present only once the stored copy has been removed.
  artifact_purged_at?: string;
  // Present only while the document is still retained.
  mime_type?: string;
  content_base64?: string;
}

// Narrowed from unknown before anything trusts it: the seam hands back a
// parsed body, not a verified shape.
export const isAttestedDocument = (
  value: unknown
): value is AttestedDocument => {
  if (typeof value !== "object" || value === null) return false;

  const candidate = value as Partial<AttestedDocument>;

  return (
    typeof candidate.reference === "string" &&
    (candidate.status === "AVAILABLE" || candidate.status === "EXPIRED") &&
    typeof candidate.content_hash === "string" &&
    typeof candidate.generated_at === "string" &&
    typeof candidate.expires_at === "string"
  );
};
